// extracted by mini-css-extract-plugin
export default {"wrapper":"EditAboutForm_wrapper__ufmPH","submitWrapper":"EditAboutForm_submitWrapper__yeWz3"};